module.exports = __webpack_public_path__ + "static/img/llm_logo.d2ee7eed.svg";